import { ApiService } from "@utils/apiService";
import { inject, Injectable } from "@angular/core";
import { responseDAO } from "@app/interfaces/requests.dao";
import { API_ROUTES } from "@utils/apiRoutes";
import { AlertService } from "@app/services/alert.service";
import { tap } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AlertMessageService {

  private apiService = inject(ApiService);
  private alertService = inject(AlertService)

  putAlertMessage(body: any) {
    return this.apiService.put<responseDAO>(`${API_ROUTES.administrator.routes.alertMessage}`, body).subscribe({
      next: (response) => {
        this.alertService.alert('success', response.message);
      },
      error: (error) => {
        this.alertService.alert('error', error.message);
      }
    });
  }

  getConfigurationById(sourceId: number) {
    const url = `${API_ROUTES.administrator.routes.alertMessage}/${sourceId}`;
    return this.apiService.get<responseDAO>(url);
  }

  getAllConfigurations() {
    return this.apiService.get<responseDAO>(`${API_ROUTES.administrator.routes.alertMessage}`);
  }

  updateConfiguration(sourceId: number, body: any) {
    const url = `${API_ROUTES.administrator.routes.alertMessage}/${sourceId}`;
    return this.apiService.put<responseDAO>(url, body).pipe(
      tap({
        next: (response) => this.alertService.alert('success', response.message || 'Actualizado con éxito'),
        error: (error) => {
          const errorMessage = error?.error?.message || 'Ocurrió un error al actualizar';
          this.alertService.alert('error', errorMessage);
        }
      })
    );
  }


  saveSchedulerConfig(body: any) {

    // Ajusta la ruta según tu API de Express
    const url = `${API_ROUTES.administrator.routes.alertMessage}/scheduler-config`;
    return this.apiService.post<responseDAO>(url, body).pipe(
      tap({
        next: (res) => this.alertService.alert('success', 'Programación guardada en Redis'),
        error: (err) => this.alertService.alert('error', 'Error al guardar programación')
      })
    );
  }

  /**
   * Obtiene la programación actual de Redis
   */
  getSchedulerConfig() {

    const url = `${API_ROUTES.administrator.routes.alertMessage}/scheduler-config`;
    return this.apiService.get<responseDAO>(url);
  }


}
